export const getLoggedUser = (state) => state.auth.user
export const getLoggedUserPermissions = (state) => state.auth.permissions || []
export const getLoggedUserModules = (state) => state.auth.modules || []
export const getToken = (state) => state.auth.token
export const getValidUntil = (state) => state.auth.valid_until

export const getIsLoading = (state) => state.auth.status === 'pending'
export const getError = (state) => state.auth.errors
